// export const API_URL = 'https://manager.checkinanalytics.com';
// export const API_URL = 'http://localhost:8000';
export const API_URL = 'https://api.checkinanalytics.com';
